export default [
  {
    title: 'Privileges',
    customIcon: 'PrivilegeSVG',
    children: [
      {
        title: 'Privilege List',
        route: 'privilege-list',
        path: '/privilege/list',
      },
      {
        title: 'Category',
        route: 'privilege-category',
        path: '/privilege/category',
      },
      // {
      //   title: 'Report',
      //   route: 'privilege-report',
      //   path: '/privilege/report',
      // },
      {
        title: 'Code Template',
        route: 'privilege-code-template-list',
        path: '/privilege/code-template/list',
      },
    ],
  },
];
